<template>
  <div>
    <search-traffic-scene @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowMenu('traffic_scenes/new')"
        >新增</a-button>

        <update-effective
          v-if="isShowMenu('traffic_scenes/effective')"
          :selected-row-keys="selectedRowKeys"
          @completed="fetchData"
        />
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record.id)" v-if="isHasEditPermission">编辑</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 新增模态框 -->
    <new-traffic-scene
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <!-- 编辑模态框 -->
    <edit-traffic-scene
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findTrafficScenes } from '@/api/traffic_scene'
import Pagination from '@/components/Pagination'
import SearchTrafficScene from '@/views/traffic_scenes/Search'

export default {
  name: 'TrafficSceneList',
  components: {
    Pagination,
    SearchTrafficScene,
    EditTrafficScene: () => import('@/views/traffic_scenes/Edit'),
    NewTrafficScene: () => import('@/views/traffic_scenes/New'),
    UpdateEffective: () => import('@/views/traffic_scenes/UpdateEffective')
  },
  data() {
    return {
      data: [],
      columns: [
        {
          title: '运营商',
          dataIndex: 'carrier_type',
          width: 110
        },
        {
          title: '场景名称',
          dataIndex: 'name',
          width: 160
        },
        {
          title: '通信制式',
          dataIndex: 'comm_mode',
          width: 100
        },
        {
          title: '月用量可超300M',
          dataIndex: 'exceed_small_traffic_limit',
          width: 130
        },
        {
          title: '支持机卡分离解绑',
          dataIndex: 'device_sim_unbind',
          width: 120
        },
        {
          title: '支持跨省不锁卡',
          dataIndex: 'cross_province_no_lock',
          width: 110
        },
        {
          title: '支持敏感地区使用',
          dataIndex: 'sensitive_area_usage',
          width: 120
        },
        {
          title: '需要个人实名',
          dataIndex: 'personal_real_name',
          width: 100
        },
        {
          title: '切网模式',
          dataIndex: 'network_switch_mode',
          width: 100
        },
        {
          title: '状态',
          dataIndex: 'effective',
          width: 80
        },
        {
          title: '操作',
          width: 80,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      loading: true,
      isShowEditModal: false, // 是否显示编辑表单弹窗
      isShowNewModal: false, // 是否显示新增表单弹窗
      editingId: 0, // 正在编辑的记录id
      selectedRowKeys: [],
      pagination: {
        total_count: 0
      },
      query: { effective: '1' }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    isHasEditPermission() {
      return hasPermission('traffic_scenes/edit')
    }
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findTrafficScenes(Object.assign({}, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
